import './components/pomo-app.js'
import './components/header.js'

const app = document.createElement('pomo-app')
const root = document.getElementById('root')
if (root) {
  root.appendChild(app)
}
